import type { Binding } from "./types";

export class ApiFailure extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
  }
}

export async function request<T>(binding: Binding, endpoint: string, body?: unknown): Promise<T> {
  const hasBody = body !== undefined;
  const response = await fetch(endpoint, {
    method: hasBody ? binding.http.protocol.post : undefined,
    credentials: binding.http.protocol.same_origin as RequestCredentials,
    headers: hasBody
      ? { [binding.http.protocol.content_type]: binding.http.protocol.json }
      : undefined,
    body: hasBody ? JSON.stringify(body) : undefined,
  });
  if (!response.ok) throw new ApiFailure(response.status, binding.prose.failure);
  return response.status === 204 ? (undefined as T) : response.json() as Promise<T>;
}

export function endpoint(prefix: string, identity: string, suffix: string): string {
  return prefix + encodeURIComponent(identity) + suffix;
}
